import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

// Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
export const Route = createFileRoute("/_site/pricing")({
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "Pricing and Engagement Models",
      description: "Fixed-fee packages and retainer options for business plans, funding preparation, and operations work.",
      path: "/pricing",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"Pricing"} intro={"[SUPPLY: package names and fees]"} />;
}
